import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { ConfluenceAPI, PageContent } from 'lib/confluence';
import {
  Container,
  Input,
  Illustration,
  Icon,
  ContainerLoader,
} from 'lib/raul';

import { OMenuItem } from 'lib/omnibar';
import { HOMEPAGE_ID } from 'lib/config';
import { APP } from 'lib/strings';
import { setMetaTags, hrefTitle } from 'lib/utils';

import { ReactComponent as Logo } from './logo.svg';

interface Props {
  items?: OMenuItem[];
  onSearch: (searchTerm: string) => void;
}

const Home = ({ items, onSearch }: Props) => {
  const [pageContent, setPageContent] = useState<PageContent>();

  // Load Article Data
  useEffect(() => {
    (async () => {
      const api = new ConfluenceAPI();
      const content = await api.getPageContent(HOMEPAGE_ID);

      if (!content) return;

      setPageContent(content);
      setMetaTags(content.title, content.excerpt);
    })();
  }, []);

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key !== 'Enter') return;

    const searchTerm = event.currentTarget.getAttribute('value');

    if (!searchTerm) return;
    onSearch(searchTerm);
  };

  return (
    <>
      <div className="r-bg-primary r-flex-col">
        <div className="md:r-w-3/5 r-p-9">
          <h1 className="r-heading-hero r-text-white r-py-5">{APP.HERO}</h1>
          <div className="r-bg-white r-shadow-xl r-mb-5">
            <Input
              onKeyDown={onKeyDown}
              placeholder={APP.SEARCH}
              type="search"
            />
          </div>
        </div>
      </div>
      <div className="r-flex r-flex-wrap">
        <div className="md:r-w-3/5">
          <Container addShadow className="md:r-px-9 r-pt-9 r-pb-6 content">
            <>
              <div className="lg:r-w-2/5 md:r-w-1/2 r-mb-6">
                <Logo />
              </div>
              {pageContent ? (
                <div dangerouslySetInnerHTML={{ __html: pageContent.body }} />
              ) : (
                <ContainerLoader />
              )}
            </>
          </Container>
          <div className="r-flex r-flex-col md:r-flex-row md:r-flex-wrap md:r-px-9 r-px-6">
            {items?.map(({ icon, pageId, title }, idx) => {
              if (title === APP.HOME_NAV) return '';

              const padding = idx % 2 === 0 ? 'r-pl-3' : 'r-pr-3';

              return (
                <Link
                  key={pageId}
                  className={`md:${padding} md:r-w-1/2 r-text-center r-mb-6`}
                  to={`/article/${pageId}/${hrefTitle(title)}`}
                >
                  <Container addShadow>
                    <>
                      <Icon
                        className="r-icon-4xl r-text-primary r-mb-4"
                        icon={icon}
                      />
                      <h3 className="r-heading-md r-h-6">{title}</h3>
                    </>
                  </Container>
                </Link>
              );
            })}
          </div>
        </div>
        <div className="md:r-w-2/5 r--9 content r-hidden md:r-block">
          <div className="r-mb-10">
            <Illustration
              alt={APP.OTHER_WAYS}
              className="r-object-cover r-block r-m-auto"
              name="walking"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
